(function($) {
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,
        ajax :  {},
        fetch: new ScrollMagic.Scene(),

        splitText : {},

        loadAnimations: function(){
            var timeline = new TimelineMax();

            if (__.global.screen === "large") {

                __.splitText.banner_title =  __.global.splitText($( '.pg-about-banner--title' ));
                __.splitText.banner_text =  __.global.splitText($( '.pg-about-banner--content-text p' ));


                timeline
                .add(TweenMax.to('.pg-about-content', 0, {opacity: 1 }), '+=1')
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up), '+=0.2')
                .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left) )
                .add(TweenMax.from('.pg-about-banner--image__desktop', 0.4, __.global.animations.slide.left) );

                __.global.staggerDisplay( __.splitText.banner_title, timeline);
                timeline.add(TweenMax.from('.pg-about-banner--body', 0.2, __.global.animations.slide.up));

                __.global.staggerDisplay( __.splitText.banner_text, timeline);
                timeline.call(function() {
                    __.splitText.banner_title.revert();
                    __.splitText.banner_text.revert();

                });
                timeline
                .add(TweenMax.to('.pg-about-content', 0, {opacity: 1 }), '0')

                .call(function() {
                    __.global.completeLoadInAnimation();
                })
                
                .call(function() {
                    // __.global.completeLoadInAnimation();
                    __.pageParallax();

                });
                timeline.play();
            }
            else{
                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.fade.down) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down), '+=0.2')
                .add(TweenMax.from('.pg-about-banner--image__mobile', 0.4, __.global.animations.fade.right) );
                timeline.play();
            }
        },
        mapParallax : function(){
            var mapTween = new TimelineMax();
            var map = $('.pg-google-map');
            map.addClass('j-scroll--enabled');
            mapTween
                .add(TweenMax.from('.pg-office-map--overlay', 0.5,  __.global.animations.slide.left) )
                .add(TweenMax.from('.pg-office-map--overlay', 0.5, {background: '#ef4035' }) )
                
                .staggerFrom(__.global.prepareText( $( '.pg-office-map--overlay-text' ) ), 1, __.global.animations.slide.up, 0 )
                .add(TweenMax.from('.pg-office-map--overlay-link', 0.5,  __.global.animations.slide.up, 0 ) )

                .call(function() {
                   // map.addClass('j-scroll--display');
                })
                ;
            new ScrollMagic.Scene({
                duration: 200,
                triggerHook: 1,
                triggerElement: '.pg-office-map'
            })
            .setTween( TweenMax.from('.pg-google-map',1,  __.global.animations.fade.up) )
            .addTo(__.controller);


            new ScrollMagic.Scene({
                duration: $('.pg-office-map--overlay-row').height(),
                triggerHook: 1,
                offset: 100,
                triggerElement: '.pg-office-map--overlay-row'
            })
            .setTween( mapTween )
            .addTo(__.controller);


            new ScrollMagic.Scene({
                offset: $('.pg-office-map--overlay-row').height(),
                duration: 0,
                triggerHook: 1,
                triggerElement: '.pg-office-map--overlay-row'
            })
            .setClassToggle(".pg-google-map", "j-scroll--display")
            .addTo(__.controller);
            
        },        
        pageParallax : function(){

            new ScrollMagic.Scene({
                duration: '100%',
                triggerHook: 0,
            })
            .setTween( TweenMax.to('.pg-about-banner--image__desktop', 0.4, {transform: 'translateY(250px)'})  )
            .addTo(__.controller);
            
        },
        pointsAnimations: function(){
            var timeline = new TimelineMax();

            __.splitText.callout_title =  __.global.splitText($( '.pg-about-callout--head-title' ));

            timeline.add(TweenMax.from('.pg-about-callout', 1, __.global.animations.fade.up) );
            __.global.staggerDisplay( __.splitText.callout_title, timeline);
            __.global.staggerDisplay( __.splitText.callout_title, timeline);
            timeline.call(function(){
                __.splitText.callout_title.revert();
                __.splitText.callout_text.revert();
            });

            new ScrollMagic.Scene({
                duration: '33%',
                offset: 200,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-callout'
            })
            .setTween( timeline )
            .addTo(__.controller);

            var timeline2 = new TimelineMax();
            var count = 0;


            __.splitText.callouts_headers =  __.global.splitText($( '.pg-about-callout--single-header' ));
            __.splitText.callouts_titles =  __.global.splitText($( '.pg-about-callout--single-title' ));

            
            $('.pg-about-callout--single').each(function(){
                var _this = $(this);
                var timelineTemp = new TimelineMax();
                var delay = '+=' + count++ * 0.25;


                timelineTemp.add(TweenMax.from(_this.find('.pg-about-callout--icon'), 1, {opacity: 0}, 0) );
                timelineTemp.staggerFrom( $(this).find('.pg-about-callout--single-header').find('.pga-text--word') , 1, __.global.animations.slide.up, 0.01, '-=0.15' );
                timelineTemp.staggerFrom( $(this).find('.pg-about-callout--single-title').find('.pga-text--word') , 1, __.global.animations.slide.up, 0.01, '-=0.15' );

                timeline2.add(timelineTemp, delay);
            });

            timeline2.call(function(){
                __.splitText.callouts_headers.revert();
                __.splitText.callouts_titles.revert();
             });
            new ScrollMagic.Scene({
                duration: '66%',
                offset: 200,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-callout--callouts'
            })
            .setTween( timeline2 )
            .addTo(__.controller);
        },
        servicesAnimations: function(){
            var timeline = new TimelineMax();

            __.splitText.callout_about_title =  __.global.splitText($( '.pg-about-card--header' ));

            timeline.add(TweenMax.from('.pg-about-cards', 1, __.global.animations.fade.up) );
            __.global.staggerDisplay( __.splitText.callout_about_title, timeline);
            timeline.call(function(){
                __.splitText.callout_about_title.revert();
            });

            new ScrollMagic.Scene({
                duration: '33%',
                offset: 200,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-cards'
            })
            .setTween( timeline )
            .addTo(__.controller);
            
			// cards animation
			$('.pg-about-card--card').each(function(){
				var currentCard = this;
				
			    var tweenCard = new TimelineMax()
			        //.to(currentCard, 0.25, {css: {fontWeight: 400, textShadow:"0px 0px 20px rgba(18, 112, 200, 1)"}});
			        .to(currentCard, 0.25, {className:"+=visible"});
			        
			    var scene = new ScrollMagic.Scene({
				    triggerElement: currentCard,
				    offset: -$(window).height()*0.3,
				    reverse: false
				})
			        .setTween(tweenCard)
			        .addTo(__.controller);
			});		                           	
        },                      
        // Function to call to setup functionality
        setup: function() {
            window._animations.global.setup();

            if (__.global.screen === "large") {

                __.loadAnimations();
                __.pointsAnimations();
                __.servicesAnimations();
                //__.mapParallax();
            }else{
                __.loadAnimations();
                $( ".pg-about-card--card" ).addClass( "visible" );
            }
            // __.scrollAnimations();
        }
    };
    // Attach Toolbox to window //
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.dan = __;
})(jQuery); // Fully reference jQuery after this point.